import { initializeApp } from 'firebase/app';
import { getFirestore, collection, doc, setDoc, getDocs, deleteDoc, getDoc } from 'firebase/firestore';
import type { ProposalData } from '../types/proposal';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || 'AIzaSyAzqczxLatm-eAhl0zAR0dhFnxeMjczlFA',
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || 'selpick-app.firebaseapp.com',
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || 'selpick-app',
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || 'selpick-app.firebasestorage.app',
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || '913637921635',
  appId: import.meta.env.VITE_FIREBASE_APP_ID || '1:913637921635:web:caea4689355863cc55b956',
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);

const COLLECTION = 'proposals';

export async function saveProposal(data: ProposalData, author?: string, existingId?: string): Promise<string> {
  const id = existingId || (data.hospname.replace(/\s+/g, '_') + '_' + Date.now());
  await setDoc(doc(db, COLLECTION, id), {
    ...data,
    author: author || '알 수 없음',
    savedAt: new Date().toISOString(),
  });
  return id;
}

export interface ProposalListItem {
  id: string;
  hospname: string;
  date: string;
  savedAt: string;
  author: string;
  theme: string;
  scores?: Record<string, number>;
  totalChecked?: number;
  checked?: boolean;
}

export async function updateProposalChecked(id: string, checked: boolean): Promise<void> {
  await setDoc(doc(db, COLLECTION, id), { checked }, { merge: true });
}

export async function listProposals(): Promise<ProposalListItem[]> {
  const snap = await getDocs(collection(db, COLLECTION));
  const list: ProposalListItem[] = [];
  snap.forEach(d => {
    const data = d.data();
    list.push({
      id: d.id,
      hospname: data.hospname || '',
      date: data.date || '',
      savedAt: data.savedAt || '',
      author: data.author || '알 수 없음',
      theme: data.theme || 'classic',
      scores: data.scores || undefined,
      totalChecked: data.totalChecked || undefined,
      checked: data.checked || false,
    });
  });
  return list.sort((a, b) => b.savedAt.localeCompare(a.savedAt));
}

export async function loadProposal(id: string): Promise<ProposalData | null> {
  const snap = await getDoc(doc(db, COLLECTION, id));
  if (!snap.exists()) return null;
  return snap.data() as ProposalData;
}

export async function deleteProposal(id: string): Promise<void> {
  await deleteDoc(doc(db, COLLECTION, id));
}
